var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 0H1.16663C0.523316 0 0 0.523316 0 1.16663V4.16663C0 4.81006 0.523316 5.33338 1.16663 5.33338H6.16663C6.81006 5.33338 7.33338 4.81006 7.33338 4.16663V1.16663C7.33338 0.523316 6.81006 0 6.16663 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 6.66663H1.16663C0.523316 6.66663 0 7.18994 0 7.83337V14.8334C0 15.4767 0.523316 16 1.16663 16H6.16663C6.81006 16 7.33338 15.4767 7.33338 14.8334V7.83337C7.33338 7.18994 6.81006 6.66663 6.16663 6.66663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8337 10.6666H9.83374C9.19031 10.6666 8.66699 11.1899 8.66699 11.8334V14.8334C8.66699 15.4767 9.19031 16 9.83374 16H14.8337C15.4771 16 16.0004 15.4767 16.0004 14.8334V11.8334C16.0004 11.1899 15.4771 10.6666 14.8337 10.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8337 0H9.83374C9.19031 0 8.66699 0.523316 8.66699 1.16663V8.16663C8.66699 8.81006 9.19031 9.33338 9.83374 9.33338H14.8337C15.4771 9.33338 16.0004 8.81006 16.0004 8.16663V1.16663C16.0004 0.523316 15.4771 0 14.8337 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboards);
export default __webpack_public_path__ + "static/media/dashboards.db8d275417138827151a66895f928e6c.svg";
export { ForwardRef as ReactComponent };